import styled, { css } from "styled-components";
import { theme } from "../../../../constants/StyledComponents";

export const StyledManagementTable = styled.table`
  border: 0;
  width: 100%;
  border-spacing: 0;

  tr:first-child,
  td:first-child {
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }

  tr:last-child,
  td:last-child {
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`;

export const ScrollableTableContainer = styled.div`
  max-height: calc(100dvh - 280px);
`;

export const StyledManagementTr = styled.tr<{
  $isDragging: boolean;
}>`
  height: 88px;

  ${({ $isDragging }) =>
    $isDragging &&
    css`
      display: flex;
      flex-direction: row;
      align-items: center;
      border-radius: 12px;
    `};

  &:nth-child(even) {
    background-color: ${(props) =>
      props.$isDragging ? theme.colors.purple_2 : theme.colors.white};
  }

  &:nth-child(odd) {
    background-color: ${(props) =>
      props.$isDragging ? theme.colors.purple_2 : theme.colors.purple_5};
  }
`;

export const StyledManagementTd = styled.td`
  border: 0;
  padding: 0 16px;
  & .drag-handle {
    cursor: grab;
  }
`;

export const StyledManagementTh = styled.th`
  border: 0;
  padding: 0 16px;
  height: 50px;

  & .drag-handle {
    cursor: grab;
  }
`;

export const StyledTableLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 50px);
  width: 100%;
`;
